(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["birds_product-video-carousel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-video-carousel')) {
    customElements.define('product-video-carousel', class extends HTMLElement {
      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        if (this._visibilityObserver) {
          this._visibilityObserver.disconnect();
        }
      }

      init() {
        var slider = this.querySelector('.product-video-carousel__slider');
        var prevBtn = this.querySelector('.product-video-carousel__arrow--prev');
        var nextBtn = this.querySelector('.product-video-carousel__arrow--next');
        var items = this.querySelectorAll('.product-video-carousel__item');
        if (!slider || !items.length) return;

        items.forEach(function(item) {
          var video = item.querySelector('video');
          if (video) {
            video.setAttribute('playsinline', '');
            video.setAttribute('preload', 'none');
            video.removeAttribute('autoplay');
            video.addEventListener('loadeddata', function() {
              video.classList.add('is-loaded');
            });
          }
        });

        this._visibilityObserver = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) {
            var video = entry.target.querySelector('video');
            if (!video) return;
            if (entry.isIntersecting) {
              if (video.getAttribute('preload') === 'none') {
                video.setAttribute('preload', 'auto');
                video.load();
              }
              video.play().catch(function() {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.5 });

        items.forEach(function(item) {
          this._visibilityObserver.observe(item);
        }.bind(this));

        function updateArrows() {
          if (!prevBtn || !nextBtn) return;
          prevBtn.disabled = slider.scrollLeft <= 1;
          nextBtn.disabled = slider.scrollLeft + slider.clientWidth >= slider.scrollWidth - 1;
        }

        if (prevBtn && nextBtn) {
          prevBtn.addEventListener('click', function() {
            var item = slider.querySelector('.product-video-carousel__item');
            if (item) {
              slider.scrollBy({ left: -(item.offsetWidth + 12), behavior: 'smooth' });
            }
          });

          nextBtn.addEventListener('click', function() {
            var item = slider.querySelector('.product-video-carousel__item');
            if (item) {
              slider.scrollBy({ left: item.offsetWidth + 12, behavior: 'smooth' });
            }
          });

          slider.addEventListener('scroll', updateArrows, { passive: true });
          updateArrows();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
